<template>
  <div
    class="
      @768/layout/justify:end
      $color/background:gray:eee
      color/background
      layout/grid
      layout/justify:clear
      layout/padding:bottom:page
      layout/padding:top:page
    ">
    <div
      class="
        @480/layout/align:center
        @768/layout/flex
        $typography/size:medium
        layout/grid
        layout/grid:gap:cap
        layout/padding:left:page
        layout/padding:right:page
      ">
      <p
        class="
          typography
        ">
        Floor
      </p>
      <ul
        class="
          layout/flex
          layout/height
        "
        style="--layout--height: 40px;">
        <Toggle v-for="floor in this.getFloors()" :key="floor" :currentFloor="currentFloor" :handleFloorSelection="handleFloorSelection" :floor="floor"/>
      </ul>
    </div>
  </div>
</template>

<script>
  import Toggle from './floor-toggle.vue';
  export default {
    components: {
      Toggle,
    },
    props: {
      currentFloor: {type: String, required: true, },
      handleFloorSelection: {type: Function, required: true, },
    },
    methods: {
      getFloors() {
        return [
          'LL',
          '1',
          '2',
          '3',
          '4',
          '5',
          '6'
        ]
      },
    }
  }
</script>